<template>
    <div class="attribute-group form-group col-12">
        <label>{{ $t('Choose layout') }} </label>
        <div class="product-attributes types">
            <SwiperLayout @changed-slide="updatedPhotoLayout" :index="product.attribute_values.photoLayout.index">
                <SwiperSlide v-for="attributeValue in attributes.photoLayout.attribute_values">
                    <div class="attribute">
                        <div class="image" :style="{ backgroundImage: `url(${attributeValue.preferences.imageUrl})` }">
                        </div>
                    </div>
                </SwiperSlide>
            </SwiperLayout>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SwiperSlide } from 'swiper/vue';
import SwiperLayout from "../../../../packages/views/carousel/Layout";
import useProduct from "../../useProduct";
import usePhoto from "../../usePhoto";

export default {
    components: {
        SwiperSlide,
        SwiperLayout
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
            attributes: 'product/getAttributes',
        })
    },
    setup() {
        const {
            hasElement,
            defaultNames,
            defaultDate,
            defaultPlace,
            updatedPhotoLayout
        } = usePhoto()
        const {
            updatedInputField,
        } = useProduct()

        return {
            updatedInputField,
            hasElement,
            defaultNames,
            defaultDate,
            defaultPlace,
            updatedPhotoLayout
        }
    }
}
</script>